import { HandExtendedOutlineIcon } from './HandExtendedOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F0A0EEAD-9751-407D-87C5-AA9300E15043
 * name hand-extended-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-extended-outline.svg
 * tags
 */
export const HandPalmOutlineIcon = HandExtendedOutlineIcon;
export default HandPalmOutlineIcon